export const styles = {
  textField: {
    width: '100%',
    maxWidth: '453px',
    height: '55px',
    marginTop: '40px',
  },
};
